// @flow
import { Record } from 'immutable';
import type { RecordFactory } from 'immutable';

type PostponedActionProps = {
  key: string,
  action: Object,
  onFailure: (void) => void,
  maxAttempts: ?number, // undefined - infinite
  error: ?Object,
};

export const mkPostponedAction: RecordFactory<PostponedActionProps> = Record({
  key: undefined,
  action: null,
  onFailure: undefined,
  maxAttempts: undefined,
  error: undefined,
});
